import { ChangeDetectionStrategy, Component, effect, input, output, untracked } from '@angular/core';

import { FileItem } from '../../models';

@Component({
  selector: 'evi-desktop-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  public readonly selectFolder = output<{ folder: FileItem }>();

  public readonly minLengthBeforeWrap = input<number>(4);
  public readonly numberOfVisibleStart = input<number>(1);
  public readonly numberOfVisibleEnd = input<number>(2);

  public path = input<FileItem[]>([]);

  public folders: FileItem[] = [];
  public hidden: FileItem[] = [];

  constructor() {
    effect(() => {
      const numberOfVisibleStart = this.numberOfVisibleStart();
      const numberOfVisibleEnd = this.numberOfVisibleEnd();
      const minLengthBeforeWrap = this.minLengthBeforeWrap();
      const path = this.path();

      untracked(() => {
        this.folders = [...path];
        const minLength: number = Math.max(0, minLengthBeforeWrap);

        if (this.folders.length > minLength) {
          this.cutBreadcrumb(numberOfVisibleStart, numberOfVisibleEnd);
        }
      });
    });
  }

  public trackByName(idx: number, item: FileItem): string {
    return `${item.name}-${idx}`;
  }

  public onFolderSelection(folder: FileItem): void {
    if (folder.id?.startsWith('skip-')) {
      return;
    }

    this.selectFolder.emit({ folder });
  }

  private cutBreadcrumb(numberOfVisibleStart: number, numberOfVisibleEnd: number): void {
    const length: number = this.folders.length;

    const start: number = Math.max(0, numberOfVisibleStart);
    const end: number = Math.max(1, Math.min(length, numberOfVisibleEnd));
    const menu: any = { id: 'extra' };

    this.hidden = this.folders.slice(start, length - end);
    this.folders.splice(start, (length - (end + start)), this.hidden.length ? menu : null);

    this.folders = this.folders.filter(value => !!value);
  }
}
